// 관세청 CLIP 분류사례 이미지 — atchFileId hot-link.
export const CLIP_IMG_BASE =
  "https://unipass.customs.go.kr/clip/framework/filedownload/kcs4gImageDownload.do?attchFileId=";
